export interface PolicyData {
  privacyPolicyUrl: string,
  cookiePolicyUrl: string,
  type: string,
}

/*
  Вся актуальная информация по составу регионов и политик:
  https://wiki.abbyy.com/x/NI1qAw
*/

// ABBYY USA Software House
const solutionsCountries = [
  'AF', 'AX', 'DZ', 'AS', 'AO', 'AI', 'AQ', 'AG', 'AW', 'AU',
  'BS', 'BH', 'BD', 'BB', 'BJ', 'BM', 'BT', 'BO', 'BQ', 'BW',
  'BV', 'IO', 'VG', 'BN', 'BF', 'BI', 'KH', 'CM', 'CV', 'KY',
  'CF', 'TD', 'CX', 'CC', 'KM', 'CG', 'CD', 'CK', 'CI', 'CW',
  'DJ', 'DM', 'DO', 'EG', 'GQ', 'ER', 'ET', 'FK', 'FO', 'FJ',
  'GF', 'PF', 'TF', 'GA', 'GM', 'GH', 'GI', 'GL', 'GD', 'GP',
  'GU', 'GG', 'GN', 'GW', 'HT', 'HM', 'IN', 'ID', 'IR', 'IQ',
  'JM', 'JO', 'KE', 'KI', 'KP', 'KR', 'KW', 'LA', 'LB', 'LS',
  'LR', 'LY', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MH', 'MQ',
  'MR', 'MU', 'YT', 'FM', 'MN', 'MA', 'MZ', 'MM', 'NA', 'NR',
  'NP', 'AN', 'NC', 'NZ', 'NE', 'NG', 'NU', 'NF', 'MP', 'OM',
  'PK', 'PW', 'PS', 'PG', 'PH', 'PN', 'PR', 'QA', 'RE', 'RW',
  'SH', 'KN', 'LC', 'VC', 'BL', 'MF', 'WS', 'ST', 'SA', 'SN',
  'SC', 'SL', 'SG', 'SX', 'SB', 'SO', 'ZA', 'SS', 'LK', 'SD',
  'SZ', 'SY', 'TW', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT',
  'TN', 'TV', 'UG', 'AE', 'UM', 'VU', 'VE', 'VN', 'WF', 'EH',
  'YE', 'ZM', 'ZW', 'CN', 'HK',
];

// ABBYY USA Software House
const usCountries = [
  'BZ', 'CA', 'CR', 'SV', 'GT', 'HN', 'MX', 'MS', 'NI', 'PA',
  'PM', 'TC', 'US', 'VI', 'JP'
];

// ABBYY Europe GmbH
const euCountries = [
  'AD', 'AT', 'BE', 'DK', 'FI', 'FR', 'DE', 'VA', 'IS', 'IE',
  'IT', 'LI', 'LU', 'MC', 'NL', 'NO', 'PT', 'SM', 'ES', 'SE',
  'CH', 'GB', 'AL', 'BA', 'BG', 'CY', 'CZ', 'EE', 'GR', 'HR',
  'HU', 'LT', 'LV', 'MD', 'MK', 'MT', 'ME', 'PL', 'RO', 'RS',
  'SK', 'SI', 'UA', 'GE', 'IM', 'JE', 'SJ', 'TR'
];

export const getPolicyData = (countryCode: string): PolicyData => {
  if (usCountries.includes(countryCode)) {
    const exceptionCountries = ['CA', 'JP']; // для этих стран особая логика
    const isExceptionCountry = exceptionCountries.includes(countryCode);
    let type = 'US'
    if (isExceptionCountry) {
      type = 'CA_JP'
    }
    return {
      privacyPolicyUrl: 'https://www.abbyy.com/privacy/?version=ABBYYUSASoftwareHouse',
      cookiePolicyUrl: 'https://www.abbyy.com/cookie-policy/?version=ABBYYUSASoftwareHouse',
      type: type,
    };
  }

  if (euCountries.includes(countryCode)) {
    return {
      privacyPolicyUrl: 'https://www.abbyy.com/privacy/?version=ABBYYEuropeGmbH',
      cookiePolicyUrl: 'https://www.abbyy.com/cookie-policy/?version=ABBYYEuropeGmbH',
      type: 'EU'
    };
  }

  if (solutionsCountries.includes(countryCode)) {
    return {
      privacyPolicyUrl: 'https://www.abbyy.com/privacy/?version=default',
      cookiePolicyUrl: 'https://www.abbyy.com/cookie-policy/?version=default',
      type: 'SOLUTIONS'
    };
  }

  return {
    privacyPolicyUrl: 'https://www.abbyy.com/privacy/?version=default',
    cookiePolicyUrl: 'https://www.abbyy.com/cookie-policy/?version=default',
    type: 'ALL'
  };
};
